import {InjectionToken, Provider} from '@angular/core';
export let USER_SERVICE: any = new InjectionToken<any>('tt.userService');

export function userServiceFactory(i: any): any {
	return i.get('userService');
}

export const userServiceProvider: Provider = {
	provide: USER_SERVICE,
	useFactory: userServiceFactory,
	deps: ['$injector']
};



// WEBPACK FOOTER //
// ./src/app/shared/upgrade/user.service.ts